<div class="restriction-warning-dialog">
  <mat-dialog-content>
    <div class="warning-content">
      <div class="warning-icon">
        <span class="warning-icon-text">i</span>
      </div>

      <h2 style="margin-bottom: 10px;">Are you sure?</h2>

      <p class="warning-message" [innerHTML]="message"></p>

      <ul class="restrictions-list">
        <li *ngFor="let restriction of restrictions" class="restriction-item">
          <span class="bullet">●</span>
          <span class="restriction-name">{{ restriction.name }}</span>
        </li>
      </ul>
    </div>
  </mat-dialog-content>

  <div class="dialog-actions">
    <button class="btn-no" (click)="onNo()">
      No
    </button>
    <button class="btn-yes" (click)="onYes()">
      Yes
    </button>
  </div>
</div>
